import React from "react";
import { Link } from "react-router";
import { Logo } from "../../../core/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import "./tlSiteStatCard.scss";

const INSPIRATION_ALL_REVIEWS_ROUTE = WebRoutes.inspiration({ types: [ ContentType.Review ] });

export class TLSiteStatCard extends React.PureComponent {
  public render() {
    return (
      <div className="tl-site-rating-card">
        <Logo width={75} type="light" />

        <h3>96% of our customers would recommend us to a friend.</h3>
        <p className="cta"><Link to={INSPIRATION_ALL_REVIEWS_ROUTE}>See all of our reviews...</Link></p>
        <Link className="card" to={INSPIRATION_ALL_REVIEWS_ROUTE} />
      </div>
    );
  }
}
